// @ngInject
function PurchaseOrderAnalysisApiService($q, $window, $cookies, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'purchaseorderanalysis';

    return {
        getPurchaseOrderAnalysis: ResourcesService.apiFactory.get(endpoint),
        getSupplierBriefs: ResourcesService.apiFactory.get(endpoint + '/supplierbriefs'),
        getArticleCollectionBriefs: ResourcesService.apiFactory.get(endpoint + '/articlecollectionbriefs'),
        getMainGroupBriefs: ResourcesService.apiFactory.get(endpoint + '/maingroupbriefs')
    };

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('purchaseorderanalysis.api', [])
    .factory('PurchaseOrderAnalysisApiService', PurchaseOrderAnalysisApiService);
